import { render } from "./AddMemberModal.vue?vue&type=template&id=46c5a9cf&scoped=true"
import script from "./AddMemberModal.vue?vue&type=script&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&lang=js"

import "./AddMemberModal.vue?vue&type=style&index=0&id=46c5a9cf&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c5a9cf"]])

export default __exports__